import { render, staticRenderFns } from "./DebugPage.vue?vue&type=template&id=b15d7c12&scoped=true&lang=pug&"
var script = {}
import style0 from "./DebugPage.vue?vue&type=style&index=0&id=b15d7c12&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b15d7c12",
  null
  
)

component.options.__file = "DebugPage.vue"
export default component.exports